import { CSSProperties } from 'react';
import './Spinner.less';

interface SpinnerProps {
  containerStyles?: CSSProperties;
}

export const Spinner = (props: SpinnerProps) => {
  const { containerStyles } = props;
  return (
    <div className='load' style={{ ...containerStyles }}>
      <div className='spin-one'></div>
      <div className='spin-two'></div>
      <div className='spin-three'></div>
      <div className='spin-four'></div>
      <div className='spin-five'></div>
    </div>
  );
};
